module.exports = __webpack_public_path__ + "img/placeholder_title_kr.e6f9e46c.png";